export const apiUser = "https://mplqnp.herokuapp.com/users";
export const apiArticles = "https://mplqnp.herokuapp.com/articles";
export const apiEvents = "https://mplqnp.herokuapp.com/events";
